import { IMessagingClient, MessagingClient } from '@agoda/messaging-client';
import { AppConfiguration } from 'core/configuration/AppConfiguration';
import { getBootstrapConfig, getFeMessaging, setFeMessaging } from 'core/window/windowService';

const isProduction = AppConfiguration.isProduction();
const messagingClientMode = AppConfiguration.isProduction() ? 'production' : 'development';

// Global variables set from webpack
// API key from backend to specify messages sender
const messagingClientKey: string = process.env.MESSAGING_CLIENT_API_KEY || ''; // pragma: allowlist secret

export const getMessagingClientLibraryUrl = (inputAssetPath: string, fileName: string): string => {
    let assetPath = inputAssetPath || '/';
    if (!assetPath.endsWith('/')) {
        assetPath += '/';
    }
    return assetPath + (fileName.startsWith('/') ? fileName.substring(1) : fileName);
};

if (!getFeMessaging()) {
    const config = getBootstrapConfig();

    const context: Record<string, string> = {};
    if (config.pageConfig && config.pageConfig.sessionId) {
        context.sessionId = config.pageConfig.sessionId;
    }
    if (config.pageConfig && config.pageConfig.userId) {
        context.userId = config.pageConfig.userId;
    }

    setFeMessaging(
        MessagingClient.instantiate({
            context,
            apiKey: messagingClientKey,
            workerUrl: getMessagingClientLibraryUrl(config.assetPath, 'mcjs-worker.js'),
            polyfillsUrl: getMessagingClientLibraryUrl(config.assetPath, 'mcjs-polyfills.js'),
            mode: messagingClientMode,
            debug: !isProduction,
        }),
    );
}
export const ActivitiesMessagingClient: IMessagingClient = getFeMessaging() || {};
